import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Login() {
  const { login, authMessage, clearAuthMessage } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    clearAuthMessage();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md border">
        <div className="flex items-center gap-2 mb-6">
          <img src="/pvapplogo.png" alt="PV-report logo" className="h-10 w-10 rounded" />
          <div>
            <div className="text-lg font-semibold text-slate-900">PV-report</div>
            <div className="text-sm text-slate-500">Sign in to continue</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700">Email</label>
            <input
              type="email"
              className="mt-1 w-full rounded border px-3 py-2 focus:outline-none focus:ring focus:ring-brand-200"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (authMessage) clearAuthMessage();
              }}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700">Password</label>
            <input
              type="password"
              className="mt-1 w-full rounded border px-3 py-2 focus:outline-none focus:ring focus:ring-brand-200"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (authMessage) clearAuthMessage();
              }}
              required
            />
          </div>
          {authMessage && <div className="text-sm text-amber-700">{authMessage}</div>}
          {error && <div className="text-sm text-red-600">{error}</div>}
          <button
            type="submit"
            className="w-full bg-slate-900 text-white py-2 rounded hover:bg-slate-800 disabled:opacity-60"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
